import { cloneElement, type ReactElement } from 'react';

import { Permission } from '@/core/store/auth/auth.types';
import { useHasPermission } from '@/core/store/auth/authSelectors';

type Props = {
	permission: Permission;
	children: ReactElement<{ disabled?: boolean }>;
	fallback?: 'hide' | 'disable';
};

export const PermissionGate = ({
	permission,
	children,
	fallback = 'hide'
}: Props) => {
	const hasPermission = useHasPermission(permission);

	if (hasPermission) {
		return children;
	}

	if (fallback === 'disable') {
		return cloneElement(children, { disabled: true });
	}

	return null;
};
